export default __webpack_public_path__ + "static/media/videocall-vf.e8877dce.gif";